import React from "react";
import { SvgIcon, useTheme } from "@material-ui/core";
import { useContext } from "react";

const MissingJobsReportsIcon = (props) => {
  const theme = useTheme();
  const secondaryColor = theme.palette.secondary.main;

  return (
    <SvgIcon {...props} viewBox="0 0 48 48">
      {/* Outer frame (fills canvas) */}
      <rect x="4" y="4" width="40" height="40" rx="8" fill="currentColor" />

      {/* Grid blocks (report structure) */}
      <rect x="10" y="10" width="10" height="8" rx="2" fill="white" />
      <rect x="22" y="10" width="10" height="8" rx="2" fill="white" />

      <rect x="10" y="20" width="10" height="8" rx="2" fill="white" />

      {/* Missing block (intentional gap) */}
      {/* nothing here on purpose */}

      <rect x="22" y="30" width="10" height="8" rx="2" fill="white" />
      <rect x="10" y="30" width="10" height="8" rx="2" fill="white" />

      {/* Alert badge */}
      <circle
        cx="36"
        cy="36"
        r="6"
        fill={props.disableFill ? "" : secondaryColor}
      />

      {/* Minus sign inside badge */}
      <rect x="33" y="35" width="6" height="2" rx="1" fill="white" />
    </SvgIcon>
  );
};

export default MissingJobsReportsIcon;
